import { Component, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormGroupDirective, UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { IRsPaket } from '../../../models/rspaket';
import { RsAntragComponent } from '../../antrag/rs-antrag/rs-antrag.component';
import { IRsProdukt } from '../../../models/rsprodukt';
import { ZusammenfassungService } from '../../../service/zusammenfassung.service';
import { VereinbarungKommunikationComponent } from '../../vereinbarung-kommunikation/vereinbarung-kommunikation.component';
import { DatenschutzPolicyComponent } from '../../datenschutz-policy/datenschutz-policy.component';
import {TranslateService} from '@ngx-translate/core';
import {ProduktArt} from '../../../../shared/enum';
import { AppTextareaComponent } from '../../app-textarea/app-textarea.component';
import { IRsResult } from '../../../models/rsresult';

@Component({
  selector: 'app-rs-zusammenfassung',
  templateUrl: './rs-zusammenfassung.component.html',
  styleUrls: ['./rs-zusammenfassung.component.scss']
})
export class RsZusammenfassungComponent {

  @Input()
  parentFormGroupDirective: FormGroupDirective;

  @Input()
  formGroup: UntypedFormGroup;

  @Input()
  expertMode: boolean;

  @Input()
  produkt: IRsProdukt;

  @Input()
  paket: IRsPaket;

  @Input()
  rsAntragComponent: RsAntragComponent;

  @Input()
  versicherungssumme: string;

  @Input()
  rsResult: IRsResult;

  @Output()
  korrekturEvent = new EventEmitter();

  produktArt = ProduktArt;

  fuerWenOptions: Map<number, string> =
    new Map([
      [1, 'Für mich'],
      [2, 'Für mich und meine Kinder'],
      [3, 'Für mich, meine/n Ehepartner/in, Lebensgefährten/in und Kinder']
    ]);

  fuerWenOptionsExpert: Map<number, string> =
    new Map([
      [1, 'Versicherungsnehmer/in'],
      [2, 'Versicherungsnehmer/in und ihre/seine Kinder'],
      [3, 'VN, Ehepartner/in, Lebensgefährt/in und Kinder']
    ]);

  @ViewChild('_besondereAnmerkungen') besondereAnmerkungenComponent: AppTextareaComponent;

  constructor(public zusammenfassungService: ZusammenfassungService, public translateService: TranslateService) { }

  static createFormGroup(fb: UntypedFormBuilder) {
    return fb.group({
      besondereAnmerkungen: new UntypedFormControl(''),
      vereinbarungKommunikation: VereinbarungKommunikationComponent.createVereinbarungKommunikation(),
      datenschutzPolicy: DatenschutzPolicyComponent.createDatenschutzPolicy(),
      allgemeineVertragsgrundlagen: new UntypedFormControl('', Validators.requiredTrue),
    });
  }

  get besondereAnmerkungen() { return this.formGroup.get('besondereAnmerkungen'); }
  get vereinbarungKommunikation() { return this.formGroup.get('vereinbarungKommunikation'); }
  get datenschutzPolicy() { return this.formGroup.get('datenschutzPolicy'); }
  get allgemeineVertragsgrundlagen() { return this.formGroup.get('allgemeineVertragsgrundlagen'); }
}
